export default function filterPhoneNumberAnonymize(phoneNumber: string) {
  return `+${phoneNumber.slice(0, 1)} ${phoneNumber.slice(1, 4)} ${phoneNumber.slice(4, -5)}XXXXX`
}
